import * as React from 'react';
import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';

interface CheckboxFieldProps {
  name: string;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
}

export const CheckboxField = React.forwardRef<HTMLInputElement, CheckboxFieldProps>(
  (
    {
      name,
      label,
      disabled = false,
      required = false,
      className,
    },
    ref
  ) => {
    const { control, formState: { errors } } = useFormContext();
    const error = errors[name];

    return (
      <div className={cn('flex items-center space-x-2', className)}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Checkbox
              id={name}
              checked={field.value}
              onCheckedChange={field.onChange}
              disabled={disabled}
            />
          )}
        />
        {label && (
          <Label
            htmlFor={name}
            className={cn(
              'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
              error && 'text-destructive'
            )}
          >
            {label}
            {required && <span className="text-destructive ml-1">*</span>}
          </Label>
        )}
        {error && (
          <p className="text-sm text-destructive">{String(error.message)}</p>
        )}
      </div>
    );
  }
);

CheckboxField.displayName = 'CheckboxField';

export default CheckboxField;
